import React from 'react';

const PipelineKanbanLoader = () => {
  return (
    <div className={'pipeline-kanban-loader loader'}>
      {[...new Array(10)].map((n, idx) => (
        <div key={idx} className={'stage'}>
          <div className={'stage-title'}>
            <div className={'left'}>
              <div className={'stage-milestone loader-block'} />
            </div>
            <div className={'right'}>
              <div className={'stage-header loader-block'} />
              <div className={'stage-subheader loader-block'} />
            </div>
          </div>
          <div className={'stage-cards'}>
            {[...new Array(6)].map((n, idx) => (
              <div key={idx} className={'stage-card loader-block'}></div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PipelineKanbanLoader;
